import React, { createContext, useContext, useEffect, useState } from "react";
import {
  Badge,
  Button,
  DatePicker,
  Layout,
  notification,
  Radio,
  Skeleton,
} from "antd";
import { CommandBar, SearchBox, Tooltip } from "@fluentui/react";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import RequestStore from "../approvals/store/requeststore";
import MainStore from "../../home/store/mainStore";
import { Observer, observer } from "mobx-react-lite";
import moment from "moment";
import { NoRequest } from "./NoRequest";
import { getCurrentUser } from "../../../Utility/modules/helpers";
import { toAntPickerDate } from "../../../Utility/modules/datePicker";

import { NaocDailyProductionDetail } from "./naoc/NaocDailyProductionDetail";
import { CancellationDialog } from "./CancellationDialog";
import { RefreshCcw } from "react-feather";
import { EbendoDailyProductionDetail } from "./ebendo/EbendoDailyProductionDetail";
import { QuaiboDailyproductionDetails } from "./quaibo/QuaiboDailyproductionDetails";
import { ApprovalGrid } from "./ApprovalGrid";
import { NaocApproveDialog } from "./naoc/NaocApproveDialog";
import NaocDailyProductionStore from "../store/naocdailyproductionstore";
import { EbendoApprovalDialog } from "./ebendo/EbendoApprovalDialog";
import EbendoDailyProductionStore from "../store/ebendodailyproductionstore";
import QuaiboDailyProductionStore from "../store/quaibodailyproductionstore";
import { QuaiboApprovalDialog } from "./quaibo/QuaiboApprovalDialog";
import { toJS } from "mobx";
import { DeclineDialog } from "./DeclineDialog";
const EbendoStoreCtx = createContext(EbendoDailyProductionStore);
const QuaiboStoreCtx = createContext(QuaiboDailyProductionStore);
const { Content } = Layout;
const mainStorectx = createContext(MainStore);
const requestStoreCtx = createContext(RequestStore);
export const ApprovalBaseView = observer(() => {
  const requestStore = useContext(requestStoreCtx);
  const mainStore = useContext(mainStorectx);
  const naocDailyProductionStore = useContext(NaocDailyProductionStore);
  const ebendoDailyProductionStore = useContext(EbendoStoreCtx);
  const quaiboDailyProductionStore = useContext(QuaiboStoreCtx);
  const loadMyApproval = async () => {
    try {
      const approverId = getCurrentUser()?.id;
      const year = requestStore.productionYear;
      const assetId = mainStore.assetContextId;
      await requestStore.loadApprovals(approverId, year, assetId);
    } catch (error) {
      notification.error({
        message: "SPARS Feedback",
        description: error.message,
      });
    }
  };
  useEffect(() => {
    async function loadRequest() {
      try {
        await loadMyApproval();
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: error.message,
        });
      }
    }
    loadRequest();
  }, []);
  const dateFormat = "YYYY";
  return (
    <Layout
      style={{
        background: "#fff",
        padding: "10px",
        borderTop: "2px solid #1b5e20",
      }}
    >
      <Content>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <SubPageHeaderTitle
                title={
                  <>
                    <span>
                      {mainStore.assetContextName} Production Entry Sign-Off
                      Requests &nbsp;
                    </span>
                    <span style={{ color: "gray", fontSize: "14px" }}>
                      | {requestStore.approvalStatusHeader}
                    </span>
                    <span style={{ color: "gray", fontSize: "14px" }}> | </span>{" "}
                    <Badge count={requestStore.myApprovals.size} />
                  </>
                }
              ></SubPageHeaderTitle>
            </div>
          </div>

          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <CommandBar
                items={[
                  {
                    key: "refresh",
                    text: "Refresh",
                    onRenderIcon: () => <RefreshCcw className="qicon" />,
                    onClick: async () => {
                      requestStore.productionYear = moment().year();
                      await loadMyApproval();
                    },
                  },
                  {
                    key: "approve",

                    onRender: () => (
                      <Observer>
                        {() => (
                          <Button
                            type="primary"
                            onClick={async () => {
                              if (mainStore.assetContextId === 1) {
                                requestStore.showApprovalDialog = true;
                                await naocDailyProductionStore.getNaocDailProductionById(
                                  requestStore.selAppItem.productionId
                                );
                              } else if (mainStore.assetContextId === 2) {
                                requestStore.showEbendoApprovalDialog = true;
                                await ebendoDailyProductionStore.getEbendoDailyProductionById(
                                  requestStore.selAppItem.productionId
                                );
                              } else if (mainStore.assetContextId === 3) {
                                requestStore.showQuaiboApprovalDialog = true;
                                await quaiboDailyProductionStore.getQuaiboDailProductionById(
                                  requestStore.selAppItem.productionId
                                );
                              }

                              console.log(
                                "appitems",
                                toJS(requestStore.selAppItems)
                              );
                            }}
                            disabled={
                              requestStore.selAppItem?.approvalStatus !== 1 ||
                              requestStore.selAppItems.length === 0
                            }
                          >
                            {requestStore.selAppItems.length > 1
                              ? "Open Approve All Dialog"
                              : "Open Approve/Edit Dialog"}
                          </Button>
                        )}
                      </Observer>
                    ),
                  },
                  {
                    key: "g",
                    onRender: () => <div style={{ width: "5px" }}></div>,
                  },
                  {
                    key: "cancel",

                    onRender: () => (
                      <Observer>
                        {() => (
                          <Button
                            type="danger"
                            onClick={() => {
                              requestStore.showDeclineDialog = true;
                            }}
                            disabled={
                              requestStore.selAppItem?.approvalStatus !== 1 ||
                              requestStore.selAppItems.length === 0
                            }
                          >
                            {requestStore.selAppItems.length > 1
                              ? "Decline All Requests"
                              : "Decline Request"}
                          </Button>
                        )}
                      </Observer>
                    ),
                  },
                  {
                    key: "search",
                    onRender: () => (
                      <Tooltip title="smart quick search on the requests data displayed">
                        <SearchBox
                          placeholder="Search"
                          styles={{
                            root: {
                              width: "100%",
                              borderBottomColor: "#CBD5E0",
                            },
                          }}
                          underlined={true}
                          onChange={(ev, searchTerms) => {
                            requestStore.reqGrid.api.setQuickFilter(
                              searchTerms
                            );
                            // const filterValue = grid.current.api.filterManager.quickFilter;
                          }}
                        ></SearchBox>
                      </Tooltip>
                    ),
                  },
                  {
                    key: "labe",
                    onRender: () => (
                      <div
                        style={{
                          marginRight: "5px",
                          marginLeft: "10px",
                          paddingTop: "12px",
                        }}
                      >
                        Production Year:{" "}
                      </div>
                    ),
                  },
                  {
                    key: "",
                    onRender: () => (
                      <DatePicker
                        size="small"
                        placeholder="select production year"
                        style={{ width: "200px" }}
                        picker="year"
                        value={requestStore.selDate}
                        defaultValue={toAntPickerDate(new Date())}
                        format={dateFormat}
                        onChange={async (date, val) => {
                          try {
                            requestStore.productionYear = Number(val);

                            await loadMyApproval();
                          } catch (error) {
                            notification.error({
                              message: "SPARS Feedback",
                              description: error.message,
                            });
                          }
                        }}
                      />
                    ),
                  },
                ]}
                farItems={[
                  {
                    key: "labe",
                    onRender: () => (
                      <div style={{ marginRight: "5px" }}>Display: </div>
                    ),
                  },

                  {
                    key: "ggf",
                    onRender: () => (
                      <Radio.Group
                        defaultValue={requestStore.statusId}
                        size="small"
                        buttonStyle="solid"
                        onChange={async ({ target }) => {
                          try {
                            requestStore.statusId = target.value;
                            await loadMyApproval(requestStore.statusId);

                            const status = [
                              "All Submitted Request(s)",
                              "All Awaiting Approval Request(s)",
                              "All Approved Request(s)",
                              "All Declined Request(s)",
                            ];
                            requestStore.approvalStatusHeader =
                              status[target.value];
                          } catch (error) {
                            notification.error({
                              message: "SPARS Feedback",
                              description: error.message,
                            });
                          }

                          //console.log('change',target.value)
                          //requestStore.reqGrid.api.setQuickFilter(target.value);
                        }}
                      >
                        <Radio.Button value={0}>All Request(s)</Radio.Button>
                        <Radio.Button value={1}>Awaiting Approval</Radio.Button>
                        <Radio.Button value={2}>
                          Approved Request(s)
                        </Radio.Button>
                        <Radio.Button value={3}>
                          Declined Approvals
                        </Radio.Button>
                      </Radio.Group>
                    ),
                  },
                ]}
              />
            </div>
          </div>
        </div>
        {requestStore.isLoading ? (
          <>
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
          </>
        ) : (
          <>
            {requestStore.myApprovals.size > 0 ? (
              <ApprovalGrid />
            ) : (
              <NoRequest
                asset={mainStore.assetContextName}
                status={requestStore.status}
                year={requestStore.productionYear}
              />
            )}
          </>
        )}
        <NaocDailyProductionDetail />
        <CancellationDialog />
        <EbendoDailyProductionDetail />
        <QuaiboDailyproductionDetails />
        <NaocApproveDialog />
        <EbendoApprovalDialog />
        <QuaiboApprovalDialog />
        <DeclineDialog />
      </Content>
    </Layout>
  );
});

